<section class="top-section">
  <div class="container">
    <h1>{{ currentLang === 'no' ? 'Hjelp / FAQ – Henter Pant' : 'Help / FAQ – Henter Pant' }}</h1>

    <ng-container *ngIf="currentLang === 'no'">
      <div class="content mt-4">
        <p>Henter Pant er en digital dugnadsløsning som gjør det enkelt å samle inn penger til lag, foreninger og idrettslag gjennom henting av pant.
          <br/>Her finner du svar på de vanligste spørsmålene om opprettelse, utøvere, foresatte, inntekter og bruk av appen.</p>

        <h2>Hvordan oppretter jeg et lag i Henter Pant?</h2>
        <p>For å opprette lagprofil, gå til siden <a href="/no/henter-pant/profile?tab=sign-up">Sign up</a>.
          <br/>Når laget er opprettet, finner du invitasjonskoden i appen.
          <br/>Derfra kan du dele koden med utøvere og foresatte slik at de kan bli med i laget.
          <br/>Henter Pant er laget for digital dugnad og gjør det mulig å samle inn penger uten salg.</p>

        <h2>Hvordan registrerer jeg en utøver?</h2>
        <p>Utøveren velger rollen utøver, registrerer navn og mobilnummer, og bruker invitasjonskoden fra laget.
          <br/>Dette kobler utøveren til riktig lag.</p>

        <h2>Hvordan kobler jeg foresatt til en utøver?</h2>
        <p>Foresatt oppretter eller logger inn på en foresattprofil og kobler seg til utøveren med telefonnummer.
          <br/>Foresatt får full oversikt og kan følge opp aktiviteten.</p>

        <h2>Hva gjør jeg hvis utøveren ikke har egen telefon?</h2>
        <p>Hvis barnet ikke har egen telefon, kan foresatt gjøre hele oppsettet:</p>
        <ol>
          <li><p>Opprett utøverprofil</p></li>
          <li><p>Logg ut</p></li>
          <li><p>Opprett foresattprofil</p></li>
          <li><p>Logg inn som foresatt</p></li>
          <li><p>Send forespørsel til utøver</p></li>
          <li><p>Logg inn på utøver og godkjenn</p></li>
          <li><p>Logg inn igjen som foresatt</p></li>
        </ol>
        <p>Foresatt kan deretter håndtere alt.
          <br/>Flere foresatte kan dele innlogging for å dele på oppgavene.</p>

        <h2>Hvordan fungerer invitasjonskoden?</h2>
        <p>Invitasjonskoden sikrer at utøvere kobles til riktig lag.
          <br/>Den deles av lagleder og brukes ved registrering.</p>

        <h2>Hvordan blir deling til inntekt?</h2>
        <p>Når du deler profilen din, gjør du det enkelt å støtte laget.</p>
        <p>Slik fungerer det:</p>
        <ul>
          <li><p>Del via SMS, Facebook eller lenke</p></li>
          <li><p>Noen bestiller henting</p></li>
          <li><p>Du får varsel</p></li>
          <li><p>Du henter panten</p></li>
          <li><p>Du leverer i butikk</p></li>
          <li><p>Beløpet registreres</p></li>
        </ul>
        <p>Dette er en enkel måte å samle inn penger til lag gjennom pant.</p>

        <h2>Hvordan kan vi øke lagets inntekter?</h2>
        <p>Del profiler aktivt, svar raskt på forespørsler, vær tilgjengelig og følg opp givere.
          <br/>Mange små bidrag gir stabile inntekter over tid.</p>

        <h2>Hvor mye kan laget tjene?</h2>
        <p>Inntekten avhenger av aktivitet og nettverk.
          <br/>Lag som deler aktivt og følger opp, kan skape jevn inntekt over tid.</p>

        <h2>Hvor raskt får vi inn penger?</h2>
        <p>Laget kan tjene penger umiddelbart etter oppstart.
          <br/>Så snart hentinger begynner, registreres inntekter.</p>

        <h2>Hvor mye tid krever det?</h2>
        <p>Henter Pant er fleksibelt.
          <br/>Utøvere tar oppdrag når det passer.
          <br/>Små bidrag over tid gir effekt.</p>

        <h2>Hvorfor er pushvarsler viktig?</h2>
        <p>Pushvarsler gir beskjed om:</p>
        <ul>
          <li><p>nye henteoppdrag</p></li>
          <li><p>aksepterte oppdrag</p></li>
          <li><p>donasjoner</p></li>
        </ul>
        <p>Uten varsler kan du gå glipp av inntekter.</p>

        <h2>Hva er pausefunksjonen?</h2>
        <p>Du kan sette profilen på pause.
          <br/>Da mottar du ikke oppdrag.
          <br/>Bruk kun når du ikke er tilgjengelig.</p>

        <h2>Hvordan fordeles inntektene?</h2>
        <ul>
          <li><p>Spiller: 70 %</p></li>
          <li><p>Lag: 23 %</p></li>
          <li><p>Gi Pant: resten</p></li>
        </ul>
        <p>Kvittering lastes opp som dokumentasjon.</p>

        <h2>Hvem betaler for tjenesten?</h2>
        <p>Laget betaler abonnement. Spillere og foresatte betaler ikke.</p>

        <h2>Hva skjer hvis laget ikke betaler?</h2>
        <p>Etter 30 dager begrenses tilgangen.
          <br/>Den åpnes igjen ved betaling.</p>

        <h2>Hva er aldersgrensen?</h2>
        <p>Over 15 år kan ha egen konto.
          <br/>Under 15 krever foresatt.</p>

        <h2>Blir barna sporet?</h2>
        <p>Nei. GPS brukes ikke.
          <br/>Kun adresse for matching.</p>

        <h2>Hvordan behandles data?</h2>
        <p>Kun nødvendig data lagres. Ingen salg av data.</p>

        <h2>Hva skjer hvis henting ikke gjennomføres?</h2>
        <p>Oppdrag sendes videre til andre.</p>

        <h2>Hva hvis det er søppel i posene?</h2>
        <p>Dette er giverens ansvar.</p>

        <h2>Hva skjer ved misbruk?</h2>
        <p>Konto kan begrenses eller stenges.</p>

        <h2>Hvor lenge lagres data?</h2>
        <ul>
          <li><p>Regnskap: 5 år</p></li>
          <li><p>GPS: 7 dager</p></li>
          <li><p>Kvitteringer: 12 måneder</p></li>
        </ul>

        <h2>Kan abonnement refunderes?</h2>
        <p>Kun ved dokumentert feil.</p>

        <h2>Hvilket lovverk gjelder?</h2>
        <p>Norsk lov. Salten og Lofoten tingrett.</p>

        <h3><a href="../../../assets/legal/FAQ-HenterPant.pdf" download>Last ned fullstendig versjon av FAQ (PDF)</a></h3>

        <div class="faq-separator" aria-hidden="true"></div>
        <p class="muted">Trenger du mer hjelp?</p>
        <p>Les mer om hvordan systemet fungerer eller se våre juridiske sider:</p>
        <ul>
          <li><p><a href="/no/henter-pant/slik-fungerer-det">Slik fungerer det</a></p></li>
          <li><p><a href="/no/henter-pant/terms-and-conditions">Vilkår for bruk</a></p></li>
          <li><p><a href="/no/henter-pant/privacy-policy">Personvernerklæring</a></p></li>
        </ul>
      </div>
    </ng-container>

    <ng-container *ngIf="currentLang === 'en'">
      <div class="content mt-4" data-header-contrast="light">
        <p>Henter Pant is a digital fundraising solution that makes it easier for sports teams, clubs, and associations to raise money by collecting bottle and can deposits. 
          <br/>Here you will find answers to the most common questions about setup, athletes, parents, invitation codes, push notifications, income, and app usage.</p>

        <h2>How do I create a team in Henter Pant?</h2>
        <p>To create a team profile, go to the <a href="/en/henter-pant/profile?tab=sign-up">Sign up</a> page. 
          <br/>Once the team is created, you can find the invitation code in the app. 
          <br/>From there, share the code with athletes and parents so they can join the team. 
          <br/>Henter Pant is built for digital fundraising and makes it easier to raise money without traditional product sales.</p>

        <h2>How do I register an athlete?</h2>
        <p>The athlete selects the role <strong>Player</strong> in the app, enters their name and mobile number, and uses the invitation code from the team leader. 
          <br/>This connects the athlete to the correct team in Henter Pant.</p>

        <h2>How do I connect a parent to an athlete?</h2>
        <p>The parent creates or logs into a parent profile and connects to the athlete profile using the athlete's phone number. 
          <br/>The parent will then have full visibility into activity and earnings and can manage everything on behalf of the athlete.</p>

        <h2>What if the athlete does not have their own phone?</h2>
        <p>If the child does not have their own phone, the parent can handle the full setup.</p>
        <p>Follow these steps:</p>
        <ol>
          <li><p>Create an athlete profile</p></li>
          <li><p>Log out</p></li>
          <li><p>Create a parent profile</p></li>
          <li><p>Log in as the parent</p></li>
          <li><p>Send a request to the athlete profile</p></li>
          <li><p>Log in to the athlete profile and approve the request</p></li>
          <li><p>Log back in as the parent</p></li>
        </ol>
        <p>The parent profile can then be used to manage everything on behalf of the child. 
          <br/><strong>If more than one parent is helping, they can share the login for the parent profile to reduce friction and share the workload.</strong></p>

        <h2>How does the invitation code work?</h2>
        <p>The invitation code ensures that athletes join the correct team during registration. 
          <br/>It is shared by the team leader and used to connect users to the team securely and correctly.</p>

        <h2>How does sharing turn into income?</h2>
        <p>When you share your profile, you make it easy for others to support the team. 
          <br/>This is a key part of fundraising without selling products.</p>
        <p>Here is how it works:</p>
        <ul>
          <li><p>You share your profile by SMS, Facebook, or direct link</p></li>
          <li><p>Someone requests a pickup</p></li>
          <li><p>You receive a notification in the app</p></li>
          <li><p>You collect the bottles and cans</p></li>
          <li><p>You return them in-store</p></li>
          <li><p>The amount is registered to you and your team</p></li>
        </ul>
        <p>The easier you make it to support, the more activity and income you create over time. 
          <br/>This makes Henter Pant a practical deposit app for teams and associations.</p>

        <h2>How can we increase our team’s income?</h2>
        <p>To get the most out of Henter Pant, the team should share profiles actively within its network, respond quickly to pickup requests, stay available for tasks, and follow up repeat supporters over time. 
          <br/>Many small contributions over time create stable income. 
          <br/>This is an effective way to raise money for sports teams and associations.</p>

        <h2>How much can a team earn with Henter Pant?</h2>
        <p>Earnings depend on activity, network, and consistency. 
          <br/>Teams that actively share profiles and respond quickly to pickup requests can generate steady income over time. 
          <br/>Many small pickups add up, making this a practical way to raise money for sports teams and associations.</p>

        <h2>How fast do we start earning money?</h2>
        <p>Teams can start earning immediately after setup. 
          <br/>As soon as profiles are shared and pickup requests come in, income is generated. 
          <br/>Most teams see their first results shortly after they begin sharing within their network.</p>

        <h2>How much time does it require?</h2>
        <p>Henter Pant is designed to be flexible. Athletes can accept pickups when it fits their schedule. 
          <br/>Even small efforts over time create meaningful results. 
          <br/>The system is built to reduce friction and make fundraising simple.</p>

        <h2>Why are push notifications important?</h2>
        <p>Push notifications are essential for success in Henter Pant. 
          <br/>They notify you about new pickup requests, accepted pickups, donations, and completed pickups. 
          <br/>Without push notifications, you risk missing requests, losing income, and reducing activity in the team.</p>

        <h2>What is the pause function?</h2>
        <p>You can pause your profile at any time. 
          <br/>When your profile is paused, you will not receive pickup requests. 
          <br/>Only use pause when you are actually unavailable.</p>

        <h2>How are deposit earnings distributed?</h2>
        <ul>
          <li><p>Player: 70%</p></li>
          <li><p>Team: 23%</p></li>
          <li><p>Gi Pant AS: remaining share for platform and operations</p></li>
        </ul>
        <p>The player uploads the receipt after returning the bottles and cans as documentation. </p>

        <h2>Who pays for Henter Pant?</h2>
        <p>The team or club pays for the subscription as an annual membership. 
          <br/>The first payment is made through Nets, and future invoices are sent through PowerOffice. 
          <br/>Players and parents do not pay.</p>

        <h2>What happens if the team does not pay the invoice?</h2>
        <p>The team gets a 30-day payment period. 
          <br/>After that, the team is temporarily restricted. 
          <br/>Access is automatically restored when the invoice is paid. 
          <br/>Players remain in the system, but team administration is affected.</p>

        <h2>What is the age requirement?</h2>
        <p>Athletes over 15 can have their own account. 
          <br/>For children under 15, a parent must create or approve the usage. 
          <br/>The parent has responsibility and full visibility.</p>

        <h2>Are children tracked with GPS?</h2>
        <p>No. Children and athletes are never tracked with GPS. 
          <br/>Only address is used to match relevant pickups. 
          <br/>Parents may optionally enable GPS, and that data is automatically deleted after 7 days.</p>

        <h2>How is personal data handled?</h2>
        <p>We only store the information necessary to provide the service. We never sell data and only share it with required providers for payments, invoicing, hosting, and technical stability. Full details are available in the Privacy Policy.</p>

        <h2>What happens if the bags are not collected?</h2>
        <p>If a pickup is not completed, the request is forwarded to other available players or teams in the area. Gi Pant AS only provides the platform and cannot be held responsible for failure to complete the pickup.</p>

        <h2>What if there is trash or non-deposit items in the bags?</h2>
        <p>Trash, glass, or items without deposit value remain the donor’s responsibility. Repeated violations may result in warnings or exclusion from the service.</p>

        <h2>What happens in cases of fraud or misconduct?</h2>
        <p>Gi Pant may issue warnings, temporarily suspend accounts, permanently block accounts, or terminate the team subscription in severe cases. This is handled in line with the Terms of Use.</p>

        <h2>How long is data stored?</h2>
        <p>Accounts can be deleted on request. Financial and accounting data is stored for 5 years in line with bookkeeping rules. GPS data is deleted after 7 days. Receipts are stored for 12 months.</p>

        <h2>Can the subscription be refunded?</h2>
        <p>Refunds are only issued in cases of documented errors and are handled by Gi Pant through a credit note.</p>

        <h2>Which legal system applies?</h2>
        <p>Norwegian law applies. Jurisdiction is Salten and Lofoten District Court.</p>

        <h3><a href="../../../assets/legal/FAQ-HenterPant.pdf" download>Download full version of FAQ (PDF)</a></h3>

        <div class="faq-separator" aria-hidden="true"></div>
        <p class="muted">Need more help?</p>
        <p>Read more about how the system works or see our legal pages:</p>
        <ul>
          <li><p><a href="/en/henter-pant/slik-fungerer-det">How it works</a></p></li>
          <li><p><a href="/en/henter-pant/terms-and-conditions">Terms of Use</a></p></li>
          <li><p><a href="/en/henter-pant/privacy-policy">Privacy Policy</a></p></li>
        </ul>
      </div>
    </ng-container>
  </div>
</section>

